export default __webpack_public_path__ + "static/media/brand3.5e77d7ee.webp";